import axios from "axios"

const apiClient = axios.create({
    timeout: 30000, // Temps limite de requête
})

export default apiClient
